<script>
  import LegendItem from "../../primitives/LegendItem.svelte"
</script>

<div class="legend">
  <LegendItem class="col" iconClasses="fa-solid fa-party-horn" iconColor="#008328">
    <p>Exceeded</p>
  </LegendItem>
  <LegendItem class="col" iconClasses="fa-solid fa-bullseye-arrow" iconColor="#cdff07" additionalStyles="background-color: #1d341f; border-radius: 50%; padding: 0.1em;">
    <p>Complete</p>
  </LegendItem>
  <LegendItem class="col" iconClasses="fa-solid fa-siren-on" iconColor="#ff720d">
    <p>Not Complete</p>
  </LegendItem>
  <LegendItem class="col" iconClasses="fa-solid fa-do-not-enter" iconColor="#e00122">
    <p>Exempt</p>
  </LegendItem>
</div>

<style>
  .legend {
    display: flex;
    font-weight: 600;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 1.5em 0;
    justify-content: flex-end;
    background-color: #FFF;
    border-radius: 1rem;
  }
  @media(max-width: 850px) {
    .legend {
      
    }
  }
</style>